import { instance, errorService } from '@/services/api'
import { masterAPIs, templateAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { showNotification } from '@/services/calculate'
import { socketEvents } from '@/services/config'

export default {
  props: ['name', 'templateId', 'buildingGeneralId', 'type'],
  data: function() {
    return {
      visible: false,
      process: false,
      data: null,
      duration: 0,
      datafromSocket: null,
      processContent: `Your request for downloading ${this.name} template will be processed shortly...`,
      progress: 0,
      intervalId: null,
      status: 'active',
      fileName: null,
    }
  },
  created: function() {
    this.$root.$on('message-received', this.messageReceived)
  },
  beforeDestroy() {
    this.$root.$off('message-received')
  },
  mounted() {
    this.exportData()
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.duration = null
      this.$emit('clickedCancel')
    },

    exportData() {
      const that = this
      this.$notification.info({
        message: 'Export Request',
        description: (
          <div>
            <div>
              Your request for exporting {that.name} will be processed shortly.
            </div>
            <div>You will be notified once the request is completed</div>
          </div>
        ),
        duration: that.duration,
      })
      let url = templateAPIs.buildingGeneral.tenant.exportTenant(
        this.templateId,
        this.buildingGeneralId,
      )
      if (this.url) {
        url = this.url
      }
      instance
        .get(url)
        .then(response => {
          this.$notification.destroy()
          if (response.data.message) {
            showNotification('info', 'Export', response.data.message)
          } else {
            this.data = _.get(response.data, 'result', [])
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
      return buf
    },

    downloadData() {
      const that = this
      this.$notification.destroy()
      this.$notification.info({
        message: 'Downloading File',
        description: function(createElement) {
          return createElement('div', [
            createElement(
              'div',
              'Please wait while your file is downloading...',
            ),
            createElement('a-progress', {
              props: {
                percent: that.progress,
              },
              attrs: {
                status: that.status,
              },
            }),
          ])
        },
        duration: that.duration,
      })
      this.downloadProgress()
      instance
        .post(masterAPIs.download, that.datafromSocket, {
          responseType: 'arraybuffer',
        })
        .then(response => {
          if (response.status === 200) {
            var blob = new Blob([response.data])
            const fileURL = URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', that.fileName)
            document.body.appendChild(fileLink)
            that.handleCancel()
            fileLink.click()
            that.status = 'success'
            that.progress = 100
            setTimeout(function() {
              that.$notification.destroy()
            }, 1000)
          }
        })
        .catch(err => {
          that.status = 'exception'
          that.progress = 100
          setTimeout(function() {
            that.$notification.destroy()
          }, 1000)
          that.handleCancel()
          errorService(err)
        })
    },

    downloadProgress() {
      const that = this
      this.intervalId = setInterval(function() {
        if (that.progress < 50) {
          that.progress = that.progress + 1
        } else if (that.progress >= 50 && that.progress < 75) {
          that.progress = that.progress + 0.5
        } else if (that.progress >= 75 && that.progress < 90) {
          that.progress = that.progress + 0.25
        } else if (that.progress >= 90 && that.progress < 95) {
          that.progress = that.progress + 0.1
        } else if (that.progress >= 95) {
          that.progress = that.progress + 0.01
        } else {
          clearInterval(that.intervalId)
        }
      }, 200)
    },

    // socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.fileExported) {
        if (data.Status === 'SUCCESS') {
          data.name = this.name
          this.datafromSocket = {
            Type: data.Result.fileType,
            FileName: data.Result.FilePath,
            ContentType: data.Result.ContentType,
            IsUploaded: true,
          }
          const socketData = {
            EventType: 'FileExported',
            Status: 'SUCCESS',
            Result: {
              Type: data.Result.fileType,
              FileName: data.Result.FilePath,
              ContentType: data.Result.ContentType,
              IsUploaded: true,
            },
            name: this.url ? 'Analysis Sheet' : 'Tenant',
          }
          this.fileName = data.Result.FileName
          this.$root.$emit('socketMessage', socketData)
          this.downloadData()
        } else {
          showNotification(
            'warning',
            'Import',
            _.get(data.Result, 'Message', ''),
          )
        }
      } else if (data.EventType === socketEvents.error) {
        this.$notification.destroy()
        showNotification(
          'error',
          'Error',
          'There was an error while exporting file. Please try again or contact administrator.',
        )
      }
    },
  },
}
